import { render, staticRenderFns } from "./InputMultipleFile.vue?vue&type=template&id=d12b03b0&"
import script from "./InputMultipleFile.vue?vue&type=script&lang=ts&"
export * from "./InputMultipleFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports